import styled from 'styled-components'

export const ProfilePictureContainer = styled.div`
    position: relative;
    width: fit-content;
`

export const ProfilePictureImage = styled.img`
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
`

export const ChangeProfileButton = styled.button`
    position: absolute;
    bottom: 0;
    right: 0;
    background: ${({ theme }) => theme.colors.common.black};
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`